import { getUsersfromGroups } from "../components/stateQueries"
import { convertFromDate, convertToDate } from "./dateTools"

export const getOnFilterChanged =
  (setFilter: (filter: any) => void, typeKey: string = "types") =>
  (event: Event, which: string) => {
    event.preventDefault()

    switch (which) {
      case "type-picker": {
        const eventData = getEventData(event)
        setFilter((f: any) => ({ ...f, [typeKey]: eventData.map((type: any) => type.value) }))
        break
      }
      case "user-picker": {
        const eventUserData = getEventUserData(event)
        setFilter((f: any) => ({
          ...f,
          tidUserIds:
            eventUserData?.map((u: any) => {
              if (u.tiduuid) {
                return u.tiduuid
              }
              return "undefined"
            }) || [],
          connectUserIds: eventUserData?.map((u: any) => u.id) || []
        }))
        break
      }
      case "date-range-picker": {
        const eventData = getEventData(event)
        setFilter((f: any) => ({
          ...f,
          startDate: convertFromDate(eventData.from),
          endDate: convertToDate(eventData.to)
        }))
        break
      }
      case "group-picker": {
        const eventData = getEventData(event)
        if (eventData?.length > 0) {
          getUsersfromGroups(eventData)
            .then((data) => {
              const selectedGroupUsers = data.flat().filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i)
              setFilter((f: any) => ({
                ...f,
                groupUserIds: selectedGroupUsers?.map((u: any) => u.tiduuid) || [],
                groupIds: eventData
              }))
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          setFilter((f: any) => ({
            ...f,
            groupUserIds: [],
            groupIds: []
          }))
        }
        break
      }
      case "show-deleted": {
        const checked = (event as any).target.checked
        setFilter((f: any) => ({
          ...f,
          includeDeleted: checked
        }))
        break
      }
      default:
        console.warn("received invalid filter event type: ", which)
    }
  }

const getEventData = (event: any) => (event as any).detail.data

const getEventUserData = (event: any) => (event as any).detail.userData

export const saveFilter = (key: string, filter: any) => {
  localStorage.setItem(key, JSON.stringify(filter))
}

export const getFilterKey = (filterTypeKey: string, projectId: string) => `${filterTypeKey}-${projectId}`

export const loadFilter = (key: string, defaultFilter: any) => {
  const filterString = localStorage.getItem(key)

  let filter
  if (filterString) {
    try {
      filter = JSON.parse(filterString)
    } catch (e) {
      console.error("Failed to parse filter string: `", filterString, "`. Error: ", e)
    }
  }

  if (filter) {
    return { ...defaultFilter, ...filter }
  } else {
    return defaultFilter
  }
}
